import { useContext } from "react";
import { GlobalContext } from "../providers/GlobalProvider";

const useDb = () => {
  const { db } = useContext(GlobalContext);
  return db;
};

export default useDb;
